import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  AuthMethod,
  SetLoginEventContextRequestData,
  SetLoginEventContextResponseData,
  UserAuthRequestData,
  UserAuthResponseData,
} from 'src/app/@data-services/user-auth/user-auth.data-model';
import { environment } from 'src/environments/environment';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

@Injectable({
  providedIn: 'root',
})
export class UserAuthDataService {
  private readonly _http = inject(HttpClient);

  validateUser(
    eventNameIdentifier: string,
    authMethod: AuthMethod,
    identifier: string,
    extras?: { username?: string; password?: string }
  ): Observable<UserAuthResponseData> {
    const requestData: UserAuthRequestData = {
      action: 'validateUser',
      eventNameIdentifier,
      authMethod,
      identifier,
      ...(extras?.username ? { username: extras.username } : {}),
      ...(extras?.password !== undefined ? { password: extras.password } : {}),
    };

    return this._http
      .post<ApiResponse<UserAuthResponseData>>(
        environment.apiUrl + '/r1/validateUser',
        requestData
      )
      .pipe(map((response) => response.data));
  }

  /**
   * SYN-1957: Persist the current event on the Cognito user's
   * `custom:lastEvent` attribute before signIn(). Works around an Amplify v6
   * issue where clientMetadata is not reliably forwarded to the Cognito
   * CreateAuthChallenge trigger, which would otherwise send the previous
   * event's OTP email branding.
   */
  setLoginEventContext(
    email: string,
    eventIdentifier: string
  ): Observable<SetLoginEventContextResponseData> {
    const requestData: SetLoginEventContextRequestData = {
      action: 'setLoginEventContext',
      email,
      eventIdentifier,
    };
    return this._http
      .post<ApiResponse<SetLoginEventContextResponseData>>(
        environment.apiUrl + '/r1/setLoginEventContext',
        requestData
      )
      .pipe(map((response) => response.data));
  }
}
